// extracted by mini-css-extract-plugin
module.exports = {"container":"Tenants_container__3vqAz","tenantTable":"Tenants_tenantTable__3EoDE tables_table__23PGg"};